<template>
  <div>
    <div>近7天学习记录</div>
    <chart :options="option" :auto-resize="true"></chart>

  </div>
</template>

<script>
import { dateFormat } from 'assets/js/functions'

// import { graphic } from 'echarts/lib/export'
// 引入柱状图、折线、提示框组件
require('echarts/lib/chart/line')
require('echarts/lib/chart/bar')
require('echarts/lib/component/legend')
require('echarts/lib/component/tooltip')

export default {
  name: 'charts',
  data () {
    return {
      list: [],
      series: [],
      option: {}
    }
  },
  mounted () {
    this.getData()
    this.setOption()
  },
  methods: {
    getData () {
      let arr = []
      for (let i = 0; i < 20; i++) {
        let time = `2018-06-0${Math.ceil(Math.random() * 7)} ${Math.floor(Math.random() * 24)}:${Math.floor(Math.random() * 60)}:${Math.floor(Math.random() * 60)}`
        let rate = Math.ceil(Math.random() * 100)
        arr.push({
          time,
          course: '课程名称',
          rate,
          score: Math.ceil(Math.random() * 100),
          usedTime: Math.ceil(Math.random() * 200),
          passed: rate >= 60
        })
      }
      this.list = arr.sort((a, b) => { return new Date(a.time) - new Date(b.time) })
    },
    setOption () {
      let days = {}
      let seriesCount = 0
      this.list.reduce((prevDate, cur) => {
        let dateHour = dateFormat(cur.time, 'MM-dd HH')
        let temp = dateHour.split(' ')
        let date = temp[0]
        let hour = Number(temp[1]).toString()
        let day = days[date] || {}
        let arr = day[hour] || []
        arr.push(cur)
        day[hour] = arr
        days[date] = day
        seriesCount = seriesCount < arr.length ? arr.length : seriesCount
        return date
      }, '')

      let hourArr = []
      let dayArr = []
      let serieDataArr = []
      let d = 0
      for (const date in days) {
        let day = days[date]
        dayArr.push(date)
        for (let h = 0; h < 24; h++) {
          if (d === 0) { hourArr.push(h + '点') }
          let arr = day[h.toString()] || []
          for (let s = 0; s < seriesCount; s++) {
            if (d === 0 && h === 0) {
              this.series.push([])
              serieDataArr.push([])
            }
            let val = 0
            let obj = null
            if (arr.length > s) {
              obj = arr[s]
              val = obj.score
            }
            this.series[s].push(obj)
            serieDataArr[s].push([h, d, val])
          }
        }
        d++
      }

      let option = {
        color: ['#7cb5ec'],
        tooltip: {
          formatter: (params) => {
            let obj = this.series[params.seriesIndex][params.dataIndex]
            if (obj) {
              return `课程：${obj.course}<br />时间：${obj.time}<br />用时：${obj.usedTime}<br />得分：${obj.score}<br />正确率：${obj.rate}<br />通过：${obj.passed}<br />`
            }
          }
        },
        xAxis3D: {
          type: 'category',
          data: hourArr
        },
        yAxis3D: {
          type: 'category',
          data: dayArr
        },
        zAxis3D: {
          type: 'value'
        },
        grid3D: {
          boxWidth: 200,
          boxDepth: 80,
          viewControl: {
            alpha: 5,
            beta: 30
          },
          light: {
            main: {
              shadow: true,
              alpha: 30
            }
          }
        },
        series: serieDataArr.map(item => {
          return {
            type: 'bar3D',
            stack: 'stack',
            data: item,
            shading: 'lambert',
            itemStyle: {
              color: (params) => {
                let val = params.value[2]
                if (val === 0) {
                  return seriesCount === 1 || params.seriesIndex === 0 ? '#7cb5ec' : 'transparent'
                }
                return val < 60 ? '#ff5a60' : '#7cb5ec'
              }
            }
          }
        })
      }
      this.option = option
    }
  }
}
</script>

<style>
div.echarts {
  width: 100%;
  height: 800px;
}
</style>



// WEBPACK FOOTER //
// src/views/charts.vue